import { NotificationSchedule } from '@graphql/__generated/graphql'

const normalizedTitle = (title?: string | null) =>
  title?.trim().toLowerCase() ?? ''

/**
 * Compatibility only for schedules created before schedules were embedded in
 * email templates. New schedules must never use title as identity.
 */
export const findLegacyEmailSchedule = (
  notifications: NotificationSchedule[] | null | undefined,
  templateTitle?: string | null
) => {
  const title = normalizedTitle(templateTitle)
  if (!title) return undefined

  return notifications?.find(
    (notification) => normalizedTitle(notification.title) === title
  )
}

export const removeLegacyEmailSchedule = ({
  notifications = [],
  templateTitle,
  timestamp,
}: {
  notifications?: NotificationSchedule[] | null
  templateTitle?: string | null
  timestamp?: string | null
}): NotificationSchedule[] => {
  const title = normalizedTitle(templateTitle)
  if (!title && !timestamp) return [...(notifications ?? [])]

  return (notifications ?? []).filter(
    (notification) =>
      !(
        normalizedTitle(notification.title) === title &&
        (!timestamp || notification.timestamp === timestamp)
      )
  )
}
